<div class="container-fluid">
  <div class="col-12">
    <a href="#">
      <img src="https://img-prd-pim.poorvika.com/pageimg/Festive-deals-web-banner2025.webp" alt="Banner" class="img-fluid">
    </a>
  </div>
  <div class="col-12 mt-5">
    <div class="row">
      <div class="col">
        <a href="#">
          <img src="https://img-prd-pim.poorvika.com/pageimg/Samsung-galaxy-Z-fold-7.webp" alt="Banner 2" class="img-fluid">
        </a>
      </div>
      <div class="col">
        <a href="#">
          <img src="https://img-prd-pim.poorvika.com/pageimg/Samsung-galaxy-Z-flip-7.webp" alt="Banner 2" class="img-fluid">
        </a>
      </div>
    </div>
  </div>
  <section class="mt-5">
    <p-galleria [(value)]="images"
                [numVisible]="5"
                [circular]="true"
                [showItemNavigators]="true"
                [showThumbnails]="false"
                [responsiveOptions]="responsiveOptions"
                [containerStyle]="{ 'max-width': '1920px' }">
      <ng-template pTemplate="item" let-item>
        <a [href]="item.linkTo">
          <img [src]="item.src" style="width: 100%; display: block;" />
        </a>
      </ng-template>
    </p-galleria>
  </section>

  <div class="container-fluid mt-5" *ngIf="productCategories?.length">
    <div class="row justify-content-center">
      <p-carousel
        [value]="productCategories"
        [numVisible]="5"
        [numScroll]="2"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        [autoplayInterval]="3000"
        [showNavigators]="true"
        [showIndicators]="true"
        class="category-carousel">

        <ng-template let-category pTemplate="item">
          <div class="category-item text-center">
            <div class="category-circle d-flex align-items-center justify-content-center mb-3">
              <img
                [src]="category.image"
                [alt]="category.name"
                class="category-image rounded-circle"
                style="width: 150px; height: 150px; object-fit: cover;" />
            </div>
            <h4 class="fs-5 fw-bold text-center">{{ category.name }}</h4>
          </div>
        </ng-template>

      </p-carousel>
    </div>
  </div>

  <section *ngFor="let section of sections">
    @if (section.hasOwnProperty('type') && section.type == 'brand_slider'){
      <section class="brand-slider px-3 bg-light-gray p-3">
        <p-carousel [value]="brands" [numVisible]="12" [numScroll]="1" [circular]="true" [responsiveOptions]="responsiveOptions" autoplayInterval="3000" [showNavigators]="false">
          <ng-template let-brand pTemplate="item">
            <app-brands [brand]="brand"></app-brands>
          </ng-template>
        </p-carousel>
      </section>
    } @else {
      <app-section [section]="section"></app-section>
    }
  </section>

</div>
